(() => {
    Metro.i18n.add("it", {
        weekStart: 1,

        january: "Gennaio",
        february: "Febbraio",
        march: "Marzo",
        april: "Aprile",
        may: "Maggio",
        june: "Giugno",
        july: "Luglio",
        august: "Agosto",
        september: "Settembre",
        october: "Ottobre",
        november: "Novembre",
        december: "Dicembre",

        january_short: "Gen",
        february_short: "Feb",
        march_short: "Mar",
        april_short: "Apr",
        may_short: "Mag",
        june_short: "Giu",
        july_short: "Lug",
        august_short: "Ago",
        september_short: "Set",
        october_short: "Ott",
        november_short: "Nov",
        december_short: "Dic",

        sunday: "Domenica",
        monday: "Lunedì",
        tuesday: "Martedì",
        wednesday: "Mercoledì",
        thursday: "Giovedì",
        friday: "Venerdì",
        saturday: "Sabato",

        sunday_short: "Dom",
        monday_short: "Lun",
        tuesday_short: "Mar",
        wednesday_short: "Mer",
        thursday_short: "Gio",
        friday_short: "Ven",
        saturday_short: "Sab",

        sunday_short_2: "D",
        monday_short_2: "L",
        tuesday_short_2: "M",
        wednesday_short_2: "M",
        thursday_short_2: "G",
        friday_short_2: "V",
        saturday_short_2: "S",

        label_ok: "OK",
        label_cancel: "Annulla",
        label_done: "Fatto",
        label_today: "Oggi",
        label_now: "Adesso",
        label_clear: "Cancella",
        label_help: "Aiuto",
        label_yes: "Sì",
        label_no: "No",
        label_random: "Casuale",
        label_save: "Salva",
        label_reset: "Reimposta",
        label_submit: "Invia",
        label_add_user_color: "Aggiungi ai colori",
        label_send: "Invia",
        label_accept: "Accetta",
        label_cookies_title: "Questo sito utilizza i cookie",
        label_cookies_text: "Questo sito utilizza i cookie per garantire la migliore esperienza sul nostro sito.",
        label_choose_file: "Scegli file",
        label_drop_file: "Clicca o trascina qui il file",
        label_files_selected: "{n} file selezionati",

        label_days: "giorni",
        label_hours: "ore",
        label_minutes: "min",
        label_seconds: "sec",
        label_month: "mese",
        label_months: "mesi",
        label_day: "giorno",
        label_year: "anno",
        label_years: "anni",

        label_rows_count: "Mostra:",
        label_search: "Cerca:",
        label_table_info: "Mostra da $1 a $2 di $3 elementi",
        label_prev: "Prec",
        label_next: "Succ",
        label_all: "Tutti",
        label_inspector: "Ispettore",
        label_goto_page: "Vai a",
        label_enter_page: "Inserisci pagina...",
        label_empty: "Niente da mostrare",
        label_user_colors: "Colori utente",
        label_tiles: "Piastrelle",
        label_list: "Lista",
        label_load_more: "Carica altro",
        label_buy: "Compra",
        label_buy_now: "Compra ora",
        label_buy_today: "Compra oggi",
        label_download: "Scarica",
        label_search_results: "Risultati di ricerca",
        label_add: "Aggiungi",
        label_edit: "Modifica",
        label_delete: "Elimina",
        label_new: "Nuovo",
        label_sell: "Vendi",
        label_details: "Dettagli",
        label_sorting: "Ordinamento",
        label_finish: "Termina",
        label_play: "Riproduci",
        label_pause: "Pausa",
        label_stop: "Arresta",
        label_mute: "Silenzia",
        label_loop: "Ripeti",

        label_on: "acc",
        label_off: "spe",

        label_rename_tab: "Rinomina scheda",
        label_close_tab: "Chiudi scheda",
        label_close_other_tabs: "Chiudi altre schede",
        label_close_tabs_left: "Chiudi schede a sinistra",
        label_close_tabs_right: "Chiudi schede a destra",
        label_close_all_tabs: "Chiudi tutte le schede",
        label_close_inactive_tabs: "Chiudi schede inattive",

        label_clear_input: "Cancella input",
        label_reveal_password: "Mostra password",
        label_hide_password: "Nascondi password",
        label_generate_random: "Genera valore casuale",
        label_search_input: "Cerca il valore inserito",

        label_note: "Nota",
        label_tip: "Suggerimento",
        label_info: "Info",
        label_warning: "Avviso",
        label_question: "Domanda",
        label_error: "Errore",
        label_success: "Successo",
        label_caution: "Attenzione",
        label_alert: "Allarme",
        label_bug: "Bug",
        label_fuck: "Cavolo",
        label_important: "Importante",
        label_shit: "Accidenti",
        label_air: "Aria",

        label_select_all: "Seleziona tutto",
        label_select_more: "Seleziona...",
        label_select: "Seleziona",
        label_filter: "Filtro",

        label_collapse: "Riduci",
        label_attach: "Allegare",
    });
})();
